import React, { useCallback, useEffect, useState } from "react";
import Banner from "src/components/molecules/banner/Banner";
import BusinessList from "../business-list/business-list";
import BusinessAddNew from "../business-add-new/business-add-new";
import { BusinessProps } from "./business-main.props";
import { INewBusinessModel } from "src/types/models/apiModels";
import { useAuth } from "../auth/auth-context";
import { ErrorDisplay } from "src/components/atoms/error/error";

const Business: React.FC<BusinessProps> = ({ openInEditMode }) => {
	const { user } = useAuth(); // Extract user from useAuth hook
	const [title, setTitle] = useState("Businesses");
	const [editMode, setEditMode] = useState<boolean>(openInEditMode ?? false);
	const [canListBusinesses, setCanListBusinesses] = useState(false);
	const addBusinessCallBack = useCallback(() => {
		toggleEditMode();
	}, []); // No dependencies, so this callback won't change across renders

	const submitBusinessCallBack = useCallback(
		(business: INewBusinessModel) => {
			toggleEditMode();
		},
		[]
	);
	const cancelBusinessCallBack = useCallback(() => {
		toggleEditMode();
	}, []);

	const toggleEditMode = () => {
		setEditMode((prevValue) => !prevValue);
	};

	useEffect(() => {
		const userPermissions = user?.permissionBag.permissions;

		if (
			userPermissions &&
			userPermissions.filter(
				(p) => p.name === "Business" && p.value === "List"
			).length > 0
		) {
			setCanListBusinesses(true);
		} else {
			setCanListBusinesses(false);
		}
	}, []);

	useEffect(() => {
		if (editMode) {
			setTitle("Register a Business");
		} else {
			setTitle("Businesses");
		}
	}, [editMode]);

	// Functions to handle opening and closing the dialog

	return (
		<Banner label={title}>
			{editMode === false ? (
				<>
					{canListBusinesses ? (
						<div className="bg-white p-6 w-full overflow-auto rounded-lg drop-shadow-2xl">
							<BusinessList
								onAddNewClick={addBusinessCallBack}
							></BusinessList>
						</div>
					) : (
						<ErrorDisplay
							error={
								"You do not have sufficient permissions to see the of list businesses"
							}
						></ErrorDisplay>
					)}
				</>
			) : (
				<BusinessAddNew
					onSubmitClick={submitBusinessCallBack}
					onCancelClick={cancelBusinessCallBack}
				></BusinessAddNew>
			)}
		</Banner>
	);
};

export default Business;
